<template>
  <nav class="breadcrumbs" aria-label="Fil d'Ariane">
    <ol>
      <li v-for="(item, index) in items" :key="item.path">
        <router-link v-if="index < items.length - 1" :to="item.path">{{ item.name }}</router-link>
        <span v-else aria-current="page">{{ item.name }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
  export default {
    name: 'BreadcrumbsNav',
    props: {
      // [{name, path}] de l'accueil jusqu'à la page courante
      items: {type: Array, required: true},
    },
  }
</script>

<style lang="stylus" scoped>
@import '~/src/common/style/constants.styl';

.breadcrumbs
  font-size 0.92rem
  ol
    display flex
    flex-wrap wrap
    gap 4px 0
    list-style none
    margin 0
    padding 0
  li
    margin 0
    padding 0
    color MUTED
    &:not(:last-child)::after
      content '/'
      margin 0 8px
      color RULE
  a
    color MUTED
    text-decoration-color RULE
  span
    color INK
    font-weight 600
</style>
